import { CoveringGroup } from './coveringGroup';

export enum ReasonForLeave {
  AnnualLeave = 'annual_leave',
  LeaveOfAbsence = 'leave_of_absence',
  Other = 'other',
}

export enum HandoverStatus {
  Upcoming = 'upcoming',
  Sent = 'sent',
  Sending = 'sending',
  Received = 'received',
  Completed = 'completed',
}

export interface HandoverItem {
  id: string;
  title: string;
  // This is computed on the frontend based on the "viewed_by" property of the API response
  isNew: boolean;
  isCoveringEa: boolean;
  startDate: Date;
  endDate: Date;
  sentAt?: Date;
  completedAt?: Date;
  reasonForLeave: ReasonForLeave | undefined;
  groups: CoveringGroup[];
  status: HandoverStatus;
}
